import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createVNode as _createVNode, Teleport as _Teleport, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "w-100 flex-shrink-1 flex-grow-1 d-flex flex-column card bg-white p-5",
  style: {"overflow":"auto"}
}
const _hoisted_2 = { class: "card bg-white p-5 mb-4" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = { class: "mb-4 d-flex align-items-center" }
const _hoisted_5 = { class: "flex-shrink-0" }
const _hoisted_6 = { class: "card bg-white p-5 mb-4" }
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = { class: "d-flex flex-row align-items-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "position-buttons text-primary p-2 mr-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-bars panel-drag-handle",
    style: { opacity: '0' }
  })
], -1)
const _hoisted_12 = { class: "flex-grow-1" }
const _hoisted_13 = { class: "m-0 flex-grow-1" }
const _hoisted_14 = { class: "card bg-white p-5 mb-4" }
const _hoisted_15 = { class: "mb-4" }
const _hoisted_16 = { class: "mb-4" }
const _hoisted_17 = { class: "mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_translate = _resolveComponent("translate")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_AnimatedInput = _resolveComponent("AnimatedInput")!
  const _component_Card = _resolveComponent("Card")!
  const _component_CustomFieldEditorElement = _resolveComponent("CustomFieldEditorElement")!
  const _component_Draggable = _resolveComponent("Draggable")!
  const _component_Container = _resolveComponent("Container")!
  const _component_PropertyFolderEditor = _resolveComponent("PropertyFolderEditor")!
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!

  return (!_ctx.settings)
    ? (_openBlock(), _createBlock(_component_ProgressBar, {
        key: 0,
        mode: "indeterminate"
      }))
    : (_openBlock(), _createElementBlock("form", {
        key: 1,
        class: "container-wide flex-shrink-1 flex-grow-1 d-flex flex-column",
        style: {"min-height":"0"},
        onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)), ["prevent","stop"]))
      }, [
        (_openBlock(), _createBlock(_Teleport, { to: "#topmenu-buttons" }, [
          _createVNode(_component_Button, {
            type: "submit",
            class: "p-button-success mr-2",
            label: _ctx.i18n.$gettext('Speichern'),
            onClick: _withModifiers(_ctx.save, ["prevent","stop"])
          }, null, 8, ["label", "onClick"])
        ])),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h5", _hoisted_3, [
              _createVNode(_component_translate, null, {
                default: _withCtx(() => [
                  _createTextVNode("Sichtbarkeit der Filter")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", null, [
                _createVNode(_component_translate, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Sollen die Filter auch externen Benutzern angezeigt werden? Dies führt eventuell dazu, dass die Filter nicht wie gewünscht funktionieren, wenn Daten der Grundstücke versteckt werden.")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_InputSwitch, {
                  modelValue: _ctx.settings.showFilterViewForExternalUsers,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.settings.showFilterViewForExternalUsers) = $event))
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h5", _hoisted_7, [
              _createVNode(_component_translate, null, {
                default: _withCtx(() => [
                  _createTextVNode("Einstellungen für die zusätzlichen Felder")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("form", {
                class: "d-flex flex-row",
                onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addNewField && _ctx.addNewField(...args)), ["prevent"]))
              }, [
                _createVNode(_component_AnimatedInput, {
                  modelValue: _ctx.fieldName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fieldName) = $event)),
                  "auto-resize": "",
                  class: "flex-grow-1",
                  label: _ctx.i18n.$gettext('Feld-Name'),
                  required: ""
                }, null, 8, ["modelValue", "label"]),
                _createVNode(_component_Button, {
                  type: "submit",
                  icon: "pi pi-plus",
                  class: "ml-3 flex-shrink-0",
                  disabled: !_ctx.fieldName
                }, null, 8, ["disabled"])
              ], 32)
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uneditableFields, (name) => {
                return (_openBlock(), _createBlock(_component_Card, { class: "flat border p-4 mt-2" }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("h5", _hoisted_13, _toDisplayString(name), 1)
                      ])
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 256)),
              _createVNode(_component_Container, {
                orientation: "vertical",
                "group-name": "Fields",
                "drag-handle-selector": ".field-drag-handle,.panel-drag-handle",
                "lock-axis": "y",
                "drop-placeholder": { className:
                                   `drop-area`,
                                 animationDuration: '200',
                                 showOnTop: true },
                "drag-class": "shadow bg-color-lightgray\n                          transition duration-100 ease-in\n                          transform rotate-3 scale-110",
                "drop-class": "transition duration-100\n                          ease-in z-50 transform\n                          -rotate-2 scale-90",
                "get-child-payload": index => (_ctx.settings?.additionalFieldsTemplateList || [])[index],
                onDrop: _cache[3] || (_cache[3] = (e) => _ctx.onFieldDrop((_ctx.settings?.additionalFieldsTemplateList || []), e))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.settings?.additionalFieldsTemplateList || []), (f, j) => {
                    return (_openBlock(), _createBlock(_component_Draggable, {
                      key: f.name+j,
                      class: "mt-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CustomFieldEditorElement, {
                          field: f,
                          "can-move-up": j > 0,
                          "can-move-down": j < (_ctx.settings?.additionalFieldsTemplateList || []).length - 1,
                          onRemove: ($event: any) => (_ctx.settings?.additionalFieldsTemplateList.splice(j, 1)),
                          onMoveUp: ($event: any) => (_ctx.settings?.additionalFieldsTemplateList.splice(Math.max(j - 1, 0), 0,_ctx.settings?.additionalFieldsTemplateList.splice(j, 1)[0])),
                          onMoveDown: ($event: any) => (_ctx.settings?.additionalFieldsTemplateList.splice(Math.min(j + 1, _ctx.settings?.additionalFieldsTemplateList.length - 1), 0, _ctx.settings?.additionalFieldsTemplateList.splice(j, 1)[0]))
                        }, null, 8, ["field", "can-move-up", "can-move-down", "onRemove", "onMoveUp", "onMoveDown"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["get-child-payload"])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("h5", _hoisted_15, [
              _createVNode(_component_translate, null, {
                default: _withCtx(() => [
                  _createTextVNode("Einstellungen für die Unterlagen")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("form", {
                class: "d-flex flex-row",
                onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addNewFolder && _ctx.addNewFolder(...args)), ["prevent"]))
              }, [
                _createVNode(_component_AnimatedInput, {
                  modelValue: _ctx.folderName,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.folderName) = $event)),
                  "auto-resize": "",
                  label: _ctx.i18n.$gettext('Ordner-Name'),
                  required: ""
                }, null, 8, ["modelValue", "label"]),
                _createVNode(_component_Button, {
                  type: "submit",
                  icon: "pi pi-plus",
                  class: "ml-3",
                  disabled: !_ctx.folderName
                }, null, 8, ["disabled"])
              ], 32)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_Container, {
                orientation: "vertical",
                "group-name": "Folders",
                "drag-handle-selector": ".field-drag-handle,.panel-drag-handle",
                "lock-axis": "y",
                "drop-placeholder": { className:
                                   `drop-area`,
                                 animationDuration: '200',
                                 showOnTop: true },
                "drag-class": "shadow bg-color-lightgray\n                          transition duration-100 ease-in\n                          transform rotate-3 scale-110",
                "drop-class": "transition duration-100\n                          ease-in z-50 transform\n                          -rotate-2 scale-90",
                "get-child-payload": index => (_ctx.settings?.propertyFolderTemplateList || [])[index],
                onDrop: _cache[6] || (_cache[6] = (e) => _ctx.onFieldDrop((_ctx.settings?.propertyFolderTemplateList || []), e))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.settings?.propertyFolderTemplateList || []), (f, j) => {
                    return (_openBlock(), _createBlock(_component_Draggable, {
                      key: f.name+f.created+j,
                      class: "mt-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_PropertyFolderEditor, {
                          folder: f,
                          "can-move-up": j > 0,
                          "can-move-down": j < (_ctx.settings?.propertyFolderTemplateList || []).length - 1,
                          onRemove: ($event: any) => (_ctx.settings?.propertyFolderTemplateList.splice(j, 1)),
                          onMoveUp: ($event: any) => (_ctx.settings?.propertyFolderTemplateList.splice(Math.max(j - 1, 0), 0,_ctx.settings?.propertyFolderTemplateList.splice(j, 1)[0])),
                          onMoveDown: ($event: any) => (_ctx.settings?.propertyFolderTemplateList.splice(Math.min(j + 1, _ctx.settings?.propertyFolderTemplateList.length - 1), 0, _ctx.settings?.propertyFolderTemplateList.splice(j, 1)[0]))
                        }, null, 8, ["folder", "can-move-up", "can-move-down", "onRemove", "onMoveUp", "onMoveDown"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["get-child-payload"])
            ])
          ])
        ]),
        (_openBlock(), _createBlock(_Teleport, { to: "#breadcrumbs" }, [
          _createVNode(_component_Breadcrumb, {
            home: { icon: 'pi pi-home', to: '/' },
            model: _ctx.breadcrumbs
          }, null, 8, ["model"])
        ]))
      ], 32))
}